export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M22 22H2v-4.5l7.5-7.495 4 3.995L22 4z\"/>"
};